import React, { useState, useEffect } from 'react';
import './new-footer.styles.scss';
import { fetchFooter } from '../../../js/api/_footer';
import SubscribeBox from './subscribe-box/subscribe-box.component';
import { ReactComponent as TrinityLogo } from './image/trinity-logo.svg';
import footerStaticData from '../footer/new-footer.js';

const NewFooter = () => {
    const [footerData, setFooterData] = useState(null);
    //const [footerData, setFooterData] = useState(footerStaticData.footer);

  useEffect(() => {
    const loadMenu = async () => {
      try {
        const data = await fetchFooter({});
        console.log('footer loaded:', data.footer);
        setFooterData(data.footer || null);
      } catch (error) {
        console.error('Failed to load footer data:', error);
      }
    };
    loadMenu();
  }, []);

  const [width, setWidth] = React.useState(window.innerWidth);
  const isMobile = width < 768;

  useEffect(()=>{
    setWidth(window.innerWidth)
  },[window.innerWidth])

  return (
    <footer className="footer">
      {/* Subscribe Section */}
      {footerData?.subscribe_section && (
        <SubscribeBox subscribeSection={footerData.subscribe_section} />
      )}

      {/* Footer Main */}
      <div className="items-container">
        <div className="footer-logo-container">
          {/* Logo + Social */}
          {footerData?.logo && (
            <div className="footer-logo">
              {isMobile?<img src={footerData.logo.src} alt={footerData.logo.alt} />:<TrinityLogo className="footerlogo" />}
              {footerData.social_media?.length > 0 && (
                <div className="social-links">
                  {footerData.social_media.map((social) => (
                    <a
                      key={social.platform}
                      href={social.href || '#'}
                      target="_blank"
                      rel="noreferrer">
                      <img
                        src={social.icon_src || ''}
                        alt={social.alt || social.platform}
                        className={social.platform ? `social-icon ${social.platform} ` : "social-icon"}
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="footer-container">
          {/* Navigation Menus */}
          {footerData?.navigation_menus?.length > 0 &&
            footerData.navigation_menus.map((menu) => (
              <div key={menu.menu_id} className="footer-col">
                <h3>{menu.title || ''}</h3>
                <ul>
                  {menu.items?.map((item) => (
                    <li key={item.id}>
                      <a href={item.href || '#'}>{item.text || ''}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </div>
      </div>
      <div className="border-separate"></div>

      {/* Bottom Bar */}
      {footerData?.copyright && (
        <div className="footer-bottom">
          <p>{footerData.copyright.text || ''}</p>
          {footerData.copyright.legal_links?.length > 0 && (
            <div className="footer-links">
              {footerData.copyright.legal_links.map((link, index) => (
                <a key={index} href={link.href || '#'}>
                  {link.text || ''}
                </a>
              ))}
            </div>
          )}
          {/* <a href="#" className="back-to-top">↑</a> */}
        </div>
      )}
    </footer>
  );
};

export default NewFooter;
